<!--
@Create By Tim For 19/08/13
@轮播图组件
-->
<template>
  <div class="Banner">
    <el-carousel :interval="5000" arrow="never">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <el-image class="bannerImg" fit="fill" :src="item.imageUrl" @click="toDetail(item)"></el-image>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import axios from 'axios';
import api from '../../../config/api';

export default {
  name: 'Banner',
  data() {
    return {
      bannerList: []
    };
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      this.$axios.get(api + 'portal/carousel/list').then(res => {
        this.bannerList = res;
      });
    },
    toDetail(item) {
      if (item.link && item.link.indexOf('http') != -1) {
        window.localtion.href = item.link;
      } else if (item.link) {
        this.$router.push({ path: item.link });
      }
    }
  }
};
</script>

<style>
.Banner .el-carousel__container {
  height: 320px;
}

.Banner .el-carousel__indicators--horizontal {
  left: 80%;
}

.Banner .el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
  text-align: center;
}
</style>

<style scoped>
.Banner .bannerImg {
  width: 100%;
  height: 320px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Banner.vue